<template lang="html">
  <v-app>
    <v-responsive>
      <list-theme0001 v-if="theme === 1" :list-product="productGroup" :list-combo="productCombo" :page="params.page" :scroll-to="scroll_to" :on-scroll="onScrollProduct" :on-scroll-combo="onScrollCombo" :is-loading="isLoading" />
    </v-responsive>
  </v-app>
</template>

<script>
import { debounce } from 'debounce'
import {
  getData as getDataProduct,
  getDataCombo as getDataProductCombo
} from '@/api/product'
import listTheme0001 from '@/views/v1/menubook/themes/theme0001/Index'
export default {
  components: {
    listTheme0001
  },
  data() {
    return {
      isLoading: false,
      handle_back: {},
      scroll_to: 0,
      settingScroll: {
        product: false,
        combo: false
      },
      params: {
        combo_page: 1,
        combo_per_page: 20,
        page: 1,
        per_page: 20
      },
      theme: 1,
      productGroup: [],
      productCombo: []
    }
  },
  computed: {
    loadedProductGroupIds() {
      const ids = []
      if (this.productGroup.length) {
        this.productGroup.map(item => {
          ids.push(item.product_group_id)
        })
        return ids
      }
      return ids
    }
  },
  async created() {
    this.handle_back = JSON.parse(sessionStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_handle_back'))
    this.loadProductCombo()
    if (!this.$isEmpty(this.handle_back) && typeof this.handle_back.page_to !== 'undefined' && this.handle_back.page_to !== '') {
      for (let i = 0; i < this.handle_back.page_to; i++) {
        await this.loadGroupProduct()
      }
    } else {
      await this.loadGroupProduct()
    }
  },
  methods: {
    async loadGroupProduct() {
      this.isLoading = true
      try {
        const params = {
          page: this.params.page++,
          per_page: this.params.per_page
        }
        const { data } = await getDataProduct(params)
        this.settingScroll.product = (data.data.length < this.params.per_page)
        this.$store.state.loading_axios = false
        const data_product = data.data
        await data_product.map(item => {
          if (!this.loadedProductGroupIds.includes(item.klasifikasi_id)) {
            this.productGroup.push({
              product_group_id: item.klasifikasi_id,
              product_group_name: item.klasifikasi,
              items: data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id)
            })
          } else {
            const productGroup = this.productGroup.filter(group => {
              return item.klasifikasi_id === group.product_group_id
            })
            const index = productGroup[0].items.findIndex((e) => e.id === item.id)
            if (index === -1) {
              productGroup[0].items.push(...data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id))
            }
          }
        })
        if (!this.$isEmpty(this.handle_back) && typeof this.handle_back.page_to !== 'undefined' && this.handle_back.page_to === (this.params.page - 1)) {
          this.$vuetify.goTo(this.handle_back.scroll_to)
        }
      } catch (e) {
        this.settingScroll.product = true
        this.productGroup = []
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
      this.isLoading = false
    },
    async loadProductCombo() {
      this.isLoading = true
      try {
        const params = {
          page: this.params.combo_page++,
          per_page: this.params.combo_per_page,
          sort_column: 'published_date',
          sort_type: 'asc'
        }
        const { data } = await getDataProductCombo(params)
        this.settingScroll.combo = (data.data.length < this.params.combo_per_page)
        this.$store.state.loading_axios = false
        data.data.map(item => {
          this.productCombo.push({ ...item })
        })
      } catch (e) {
        this.settingScroll.combo = true
        this.productCombo = []
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
      this.isLoading = false
    },
    onScrollProduct: debounce(async function(val) {
      this.scroll_to = window.scrollY + 150
      if (this.settingScroll.product === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          await this.loadGroupProduct()
        }
      }
    }, 1000),
    async onScrollCombo() {
      if (this.settingScroll.combo === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          await this.loadProductCombo()
        }
      }
    }
  }
}
</script>
